import { setOffers } from '~/src/features/specialOffersContainer/store/actions';
import { TSpecOffer } from '~/src/features/specialOffersContainer/types';
import { TDispatch, TGetState } from '~/src/store';

export type TSetOfferPayload = {
    id?: TSpecOffer['id'],
    index?: number,
    value: Partial<TSpecOffer>,
}

export const setOffer = ({
    id,
    index: cachedIndex,
    value,
}: TSetOfferPayload) => (dispatch: TDispatch, getState: TGetState) => {
    const { specOffers: { offers } } = getState();
    const updatedOffers = offers.map(
        (offer, index) => (cachedIndex === index || offer.id === id) ? { ...offer, ...value } : offer,
    );
    dispatch(setOffers(updatedOffers));
};
